module.exports = __webpack_public_path__ + "static/media/active_tech.e82b7281.png";